import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import Dialog from '@material-ui/core/Dialog';
import {default as StdButton} from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  button: {
    marginLeft: '1rem'
  }
});

const Confirmation = ({onCancel, onConfirm, busy, title, message, action='OK', cancelLabel='Cancel'}) => {
  const classes = useStyles();
  return (
    <Dialog open={true} onClose={onCancel} aria-labelledby="form2-dialog-title">
      <DialogTitle id="form2-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <StdButton onClick={onCancel} color="primary">
          {cancelLabel}
        </StdButton>
        <Button onClick={onConfirm} color="primary" variant="contained" label={action} className={classes.button} busy={busy}/>
      </DialogActions>
    </Dialog>
  );
};

Confirmation.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.node.isRequired,
  action: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string,
};

export default Confirmation;
